(function() {
    'use strict';
    angular
        .module('as.search')
        .directive('searchInvitedUsers', searchInvitedUsers)
        .controller('searchInvitedUsersController', searchInvitedUsersController)

    
    searchInvitedUsers.$inject = ['$http', '$compile','$state'];
    function searchInvitedUsers($http, $compile, $state) {
        var directive = {
            restrict: 'AE',
            scope: {
                searchInitialData: '=',
                options: '=?',
            },
            controller: 'searchInvitedUsersController',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs) {
            scope.templatetype = attrs.templatetype;
            $http.get("./templates/directives/search/searchInvitedUsers.html")
                .then(function(response) {
                    var templateContent = response.data;
                    if (scope.templatetype) {
                        element.html(templateContent);
                        $compile(element.contents())(scope);
                    } else {
                        element.replaceWith($compile(templateContent)(scope));
                    }
                }).catch(function() {
                    alert($filter('asPortalLang')('Err_Refresh_Page', "Sorry for the error, Please refresh this page"));
                });
        }
    }

    searchInvitedUsers.$inject = ['$http', '$compile', '$filter'];

    searchInvitedUsersController.$inject = ['$scope', '$http', '$compile', '$state'];
    function searchInvitedUsersController($scope, $http, $compile, $state) {
        $scope.endOfData = false;
        $scope.filterApplied = false;
        $scope.dataFetchInfo = {
        	mail_id: $scope.searchInitialData.dataParams.mail_id,
        	limit: 12,
        	stream: 1
        };
        $scope.loadingData = true;
        $scope.vFetchProfiles = vFetchProfiles;
        $scope.applyFilter = applyFilter;
        $scope.resetAll = resetAll;
        $scope.fetchData = fetchData;
        $scope.objectLength = function(obj) {
        	if(obj != undefined || obj != null)
		        return Object.keys(obj).length;
		    return false;
	    };
        activate();

        function activate() {
            var mail_id = $scope.searchInitialData.dataParams.mail_id;
            fetchData(1).then(function(){$scope.loadingData = false;});
        }

        function applyFilter(){
        	if($scope.searchText.trim() != ''){
	            fetchData(0).then(function (){
	            	$scope.endOfData = false;
	            	$scope.loadingData = false;
			        $scope.filterApplied = true;
			        if($scope.objectLength($scope.resultProfiles) < $scope.dataFetchInfo.limit){
			        	$scope.endOfData = true;
			        }
	            })
        	}
        	else{
        		resetAll();
        	}
        }
        function vFetchProfiles() {
		    fetchData(2).then(function(){
		    	$scope.loadingData = false;
		    });
		}

		function resetAll(){
			$scope.resultProfiles = $scope.userData;
			$scope.filterApplied = false;
			$scope.searchText='';
			$scope.dataFetchInfo.stream = 1;
			$scope.endOfData = false;
		}

		function fetchData(intValue){
			$scope.loadingData = true;
			var data;
			if(intValue == 0){
				data = {
					mailId: $scope.dataFetchInfo.mail_id,
					columnToShow: angular.isDefined($scope.searchInitialData.dataParams.mail_time_cat_value) ? $scope.searchInitialData.dataParams.mail_time_cat_value : $scope.searchInitialData.dataParams.mail_time_cat
				};
			}
			else if(intValue == 1 || 2){
				if(intValue==2)$scope.dataFetchInfo.stream +=1;
				data = {
					mailId: $scope.dataFetchInfo.mail_id,
					limit: $scope.dataFetchInfo.limit,
					stream: $scope.dataFetchInfo.stream,
					columnToShow: angular.isDefined($scope.searchInitialData.dataParams.mail_time_cat_value) ? $scope.searchInitialData.dataParams.mail_time_cat_value : $scope.searchInitialData.dataParams.mail_time_cat
				}
			}
			if($scope.searchText || $scope.options){
				data["other_params"] = {};
				if($scope.searchText)
					data["other_params"]["name"] = $scope.searchText;
				if($scope.options)
					data["other_params"]["options"] = $scope.options;
			}
			return $http({
				url: './admin/retrive_admin_invite_mail',
				method: 'POST',
				data: data,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).success(function(response){
				if(response.data.length < $scope.dataFetchInfo.limit){
            		$scope.endOfData = true;
            	}
				if(intValue == 1){
	                $scope.userData = response.data;
	                $scope.resultProfiles = $scope.userData;
				}
				else if(intValue == 0){
					$scope.resultProfiles = response.data;
				}else if(intValue == 2){
					if(response.data.length < $scope.dataFetchInfo.limit || $scope.objectLength($scope.resultProfiles) < $scope.dataFetchInfo.limit){
			    		$scope.endOfData = true;
			    	}
			    	if(!$scope.filterApplied)
			            $scope.resultProfiles = $scope.resultProfiles.concat(response.data);
				}
			});
		}
    }
})();
